import { Injectable, Inject } from '@angular/core';
import { TranslationStore, LocalStorageTranslations } from './translation';
import { TranslationConfig } from './translation-config';
import { TranslateUseCase } from './use-case/translate.use-case';
import { TranslateUseCaseRequest } from './use-case/translate.use-case-request';
import { TranslateUseCaseResponse } from './use-case/translate.use-case-response';
import { AddTranslationsToStoreUseCaseRequest } from './use-case/add-translations-to-store.use-case-request';
import { AddTranslationsToStoreUseCase } from './use-case/add-translations-to-store.use-case';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {

    languageList: Array<string> = [];

    currentLanguage = 'hu';

    nameOfLocalStorage = 'applicationTranslations';

    constructor(
        _translationConfig: TranslationConfig,
        private _translateUseCase: TranslateUseCase,
        private _addTranslationsToStoreUseCase: AddTranslationsToStoreUseCase
    ) {
        this.languageList = _translationConfig.translatedLanguages;
    }

    setLanguage(language: string){
        this.currentLanguage = language;
    }

    addTranslations(newTranslations: TranslationStore, languageOfNewTranslations: string) {
        const addTranslationsToStoreUseCaseRequest: AddTranslationsToStoreUseCaseRequest= {
            languageOfNewTranslations: languageOfNewTranslations,
            newTranslations: newTranslations,
            nameOfLocalStorage: this.nameOfLocalStorage
        };
        this._addTranslationsToStoreUseCase.execute(addTranslationsToStoreUseCaseRequest);
    }

    translate(key: string): string {
        const translateUseCaseRequest: TranslateUseCaseRequest = {
            translationKey: key,
            language: this.currentLanguage,
            nameOfLocalStorage: this.nameOfLocalStorage
        };
        const translateUseCaseResponse: TranslateUseCaseResponse = this._translateUseCase.execute(translateUseCaseRequest) as TranslateUseCaseResponse;
        return translateUseCaseResponse.translatedText;
    }
}
